import { useEffect, useState } from "react";
import { useInterval } from "react-use";

export interface CounterProps {
  maximum: number;
  delay: null | number;
  startCounter: boolean;
}

export const useCounter = ({
  maximum,
  delay: delayProps,
  startCounter,
}: CounterProps) => {
  const [counter, setCounter] = useState(0);
  const [delay, setDelay] = useState<null | number>(startCounter ? 100 : null);
  const [isCounterStopped, setIsCounterStopped] = useState(false);

  useEffect(() => {
    setDelay(delayProps);
  }, [delayProps]);

  useEffect(() => {
    if (counter >= maximum) {
      setDelay(null);
      setIsCounterStopped(true);
    } else {
      // set incremental delay to the counter
      if (counter !== 0) {
        const speed = (counter / maximum) * 120;
        setDelay(speed);
      }
    }
    // TODO: Fix exhaustive dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter, startCounter]);

  useInterval(() => {
    setCounter((prevCount) => prevCount + 1);
  }, delay);

  const resetCounter = () => {
    setCounter(0);
  };

  return { counter, isCounterStopped, resetCounter };
};
